import { TrackerAddMealConnectorApollo, useAppContext } from '@front-activerse/common-components';
import TrackerAddMealContainer from './TrackerAddDescribeMealContainer';
import { useParams } from 'react-router-dom';

const TrackerAddDescribeMealPage = () => {
  const { post } = useAppContext();
  const extractedMeal = sessionStorage.getItem('tracker_extracted_meal');

  const extractedMealData = extractedMeal ? JSON.parse(extractedMeal) : null;

  const { dietMealId } = useParams();

  return (
    <TrackerAddMealConnectorApollo post={post}>
      {({ addMeal }: { addMeal: (input: any) => Promise<any> }) => (
        <TrackerAddMealContainer
          {...extractedMealData}
          addMeal={addMeal}
          key={dietMealId}
          dietMealId={dietMealId}
        />
      )}
    </TrackerAddMealConnectorApollo>
  );
};

export default TrackerAddDescribeMealPage;
